class CsLocalStorage {
  static ls = null;
  static bInit = false;
  static storage = {};

  static init() {
    try {
      CsLocalStorage.ls = require("local-storage");
      // console.log("Local storage: initialized");
    } catch (error) {
      CsLocalStorage.ls = null;
      // console.log("Local storage: Init failed", error);
    }
    CsLocalStorage.bInit = true;
  }

  static lsOk() {
    return this.ls !== null;
  }

  static removeStorage(key) {
    if (this.lsOk()) {
      return this.ls.remove(key);
    } else {
      let found = key in this.storage;
      if (found) {
        return delete this.storage[key];
      }
    }
    return false;
  }

  static loadByKey(key) {
    return this.lsOk() ? this.ls.get(key) : (key in this.storage ? this.storage[key] : null)
  }

  static loadStorageByExpiredTime(key, validDuration, lastUpdate = null) {
    const data = this.loadByKey(key);
    if (data) {
      const savedAtTimestamp = this.loadByKey(this.getSavedAtKey(key));
      if (savedAtTimestamp) {
        if (!lastUpdate || lastUpdate < savedAtTimestamp) {
          // If last update is greater than save point, data is expire
          const validUntil = savedAtTimestamp + validDuration;
          if (validUntil > new Date().getTime()) {
            return data;
          }
        }
      }
    }

    // null if no data | no expiry time | there is recent update | expired
    return null;
  }

  static saveStorageWithTimestamp(key, data) {
    const savedAtKey = this.getSavedAtKey(key),
      currentTimestamp = new Date().getTime();

    if (this.lsOk()) {
      this.ls.set(key, data);
      this.ls.set(savedAtKey, currentTimestamp);
    } else {
      this.storage[key] = data;
      this.storage[savedAtKey] = currentTimestamp;
    }
  }

  static getExpiryKey(key) {
    return key + ':expiry';
  }

  static getSavedAtKey(key) {
    return key + ':savedAt';
  }
}

if (!CsLocalStorage.bInit) {
  CsLocalStorage.init();
}

export default CsLocalStorage;